import React, { lazy, Suspense } from 'react';
import { Loader } from '../components/UI/Loader';
import { queries } from '../graphql/graphql';
const MapPage = lazy(() => import('./Map/MapList'));

export const Dashboard: React.FC = () => {
  return (
    <div>
      <Suspense fallback={<Loader />}>
        <MapPage queries={queries.plans.PLANS} prefix="plan" />
      </Suspense>
    </div>
  );
};
